<template>
  <div :id="componentId" class="sp6-partner-wrapper" :style="{ backgroundColor: bgColor }">
    
    <div class="sp6-partner-grid">
      <template v-for="(item, index) in partnerList">
        <a
          v-if="item.url"
          :key="`link-${index}`"
          class="sp6-partner-item sp6-partner-link"
          :href="item.url"
          target="_blank"
        >
          <img
            class="sp6-partner-logo"
            referrerpolicy="no-referrer"
            :src="item.logo"
          />
          <span class="sp6-partner-name">{{ item.name }}</span>
        </a>
        <div
          v-else
          :key="`item-${index}`"
          class="sp6-partner-item"
        >
          <img
            class="sp6-partner-logo"
            referrerpolicy="no-referrer"
            :src="item.logo"
          />
          <span class="sp6-partner-name">{{ item.name }}</span>
        </div>
      </template>
    </div>
  </div>
</template>
<script>
export default {
  name: 'PartnerSection',
  props: {
    componentId: {
      type: String,
      default: 'sp_six_module_4'
    }
  },
  data() {
    return {
      bgColor: '#F3F3F3',
      partnerList: [
        { name: '临汾优选', logo: require('../assets/img/partner_linfei.png'), url: '' },
        { name: 'JMEIX 吉美鲜', logo: require('../assets/img/partner_jmeix.png'), url: '' },
        { name: '艺树家', logo: require('../assets/img/partner_yishujia.png'), url: '' },
        { name: '地珍坊', logo: require('../assets/img/partner_dizhenfang.png'), url: '' },
        { name: '地珍坊', logo: require('../assets/img/partner_dizhenfang.png'), url: '' }
      ]
    };
  }
};
</script>
<style scoped>
.sp6-partner-wrapper {
  position: relative;
  width: 2000px;
  left: 50%;
  transform: translateX(-50%);
  padding-bottom: 20px;
  padding-top: 20px;
}

.sp6-block_11 {
  position: relative;
  width: 1400px;
  margin: 0 auto;
}

.sp6-partner-grid {
  width: 1400px;
  margin: -6px auto 0;
  display: grid;
  grid-template-columns: repeat(5, 260px);
  gap: 25px;
}

.sp6-partner-item {
  width: 260px;
  height: 106px;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  padding: 8px;
}

.sp6-partner-logo {
  max-width: 240px;
  max-height: 70px;
  display: block;
}

.sp6-partner-name {
  margin-top: 4px;
  font-size: 14px;
  color: #343638;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
}

.sp6-partner-link {
  cursor: pointer;
  text-decoration: none;
}

.sp6-partner-link:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.sp6-partner-link .sp6-partner-name {
  color: #2b83a7;
}
</style>
